"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSortedArrayByField = exports.removeDuplication = exports.isNotEmptyArray = exports.isEmptyArray = exports.getLastElement = exports.shuffle = exports.getRandomItem = exports.getRandomIntegerInRange = void 0;
const typeChecker_1 = require("./typeChecker");
/**
 * @param min 가장 작은 정수
 * @param max 가장 큰 정수
 * @returns min과 max 사이의 랜덤 정수를 생성합니다.
 */
const getRandomIntegerInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
exports.getRandomIntegerInRange = getRandomIntegerInRange;
const getRandomItem = (array) => {
    const randomIndex = (0, exports.getRandomIntegerInRange)(0, array.length - 1);
    return array[randomIndex];
};
exports.getRandomItem = getRandomItem;
const shuffle = (array) => {
    const shuffled = array.slice();
    for (let i = shuffled.length - 1; i > 0; i--) {
        const randomIndex = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[i]];
    }
    return shuffled;
};
exports.shuffle = shuffle;
const getLastElement = (array) => {
    if (!array || array.length === 0)
        return undefined;
    const lastIndex = array.length - 1;
    return array[lastIndex];
};
exports.getLastElement = getLastElement;
// 오직 비어있는 배열인지 판단하기 위한 용도로 사용, 단 사용성을 고려해 null, undefined 가 들어오면 empty array로 간주
const isEmptyArray = (arr) => {
    if ((0, typeChecker_1.isNull)(arr) || (0, typeChecker_1.isUndefined)(arr))
        return true;
    if (!(0, typeChecker_1.isArray)(arr))
        return false;
    return !(arr === null || arr === void 0 ? void 0 : arr.length);
};
exports.isEmptyArray = isEmptyArray;
const isNotEmptyArray = (arr) => {
    if (!(0, typeChecker_1.isArray)(arr))
        return false;
    return (arr === null || arr === void 0 ? void 0 : arr.length) > 0;
};
exports.isNotEmptyArray = isNotEmptyArray;
const removeDuplication = (arr, getKey) => {
    const set = new Set();
    const uniqueItems = arr.filter(item => {
        if (set.has(getKey(item))) {
            return false;
        }
        else {
            set.add(getKey(item));
            return true;
        }
    });
    return uniqueItems;
};
exports.removeDuplication = removeDuplication;
const getSortedArrayByField = (array, field, order = 'ASC') => {
    const sortedArray = array.slice();
    sortedArray.sort((a, b) => {
        if (!a[field] && !b[field])
            return 0;
        if (!a[field])
            return -1;
        if (!b[field])
            return 1;
        return a[field] > b[field] ? 1 : -1;
    });
    if (order === 'DESC')
        return sortedArray.reverse();
    return sortedArray;
};
exports.getSortedArrayByField = getSortedArrayByField;
